<template>
  <div>
    <b-form @submit.prevent="onSubmit">
      <b-form-row>
        <b-col cols="12" md="2">
          <vc-date-picker
            is-expanded
            mode="range"
            :min-date="formConfig.picker.startDate"
            :max-date="formConfig.picker.endDate"
            v-model="startingDates"
            color="red"
            @input="armarMinMax"
            :input-props="{ placeholder: 'Llegada - Salida' }"
            :popover="{ visibility: 'click' }"
            id="inputFechaCupo"
          >
            <input
              id="date"
              slot-scope="{ inputProps, inputEvents, isDragging }"
              :class="[
                `input-as elevation-1 text--grey lighten-2 caption py-2 px-3 ${
                  isDragging ? 'text-gray-400' : 'text-gray-700'
                }`
              ]"
              v-bind="inputProps"
              v-on="inputEvents"
            />
          </vc-date-picker>
        </b-col>
        <b-col cols="12" md="4" class="my-2 my-sm-0">
          <label for="inlineFormCustomSelectPref" class="text-white sr-only">Destinos:</label>
          <v-autocomplete
            v-model="form.destino"
            :items="destinos"
            solo
            color="blue-grey lighten-2"
            item-text="text"
            item-value="value"
            clearable
            dense
            v-validate="'required'"
            name="destino"
            :error-messages="errors.first('destino')"
            id="inputDestinoCupo"
          >
            <template v-slot:label>
              <small>Escriba o seleccione el destino</small>
            </template>
            <template v-slot:selection="data">
              <small>
                {{ `${data.item.text}, ${data.item.pais}` | truncateString(39) }}
              </small>
            </template>
            <template v-slot:item="data">
              <div>
                <template v-if="data.item.header">
                  <v-list-tile-content class="bk-header">
                    <p class="red--text">{{ data.item.header }}</p>
                  </v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-content>
                    <v-list-tile-title background-color="black">{{ data.item.text }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ data.item.sufijo }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </div>
            </template>
            <template slot="no-data">
              <span class="text-center">Seleccione un mes</span>
            </template>
          </v-autocomplete>
        </b-col>
        <b-col cols="12" md="4" id="containerCupo">
          <SelectorOcupacion :ocupacion="formConfig.ocupacion"></SelectorOcupacion>
        </b-col>
        <b-col cols="12" md="2" class="my-2 my-sm-0">
          <v-btn type="submit" block color="primary" dark large class="mt-0" style="height: 48px;">Buscar</v-btn>
        </b-col>
      </b-form-row>
    </b-form>
  </div>
</template>
<script>
// import PanelCupo from "@/components/cupos/PanelCupo.vue";
import moment from "moment"
import SelectorOcupacion from "@/components/utiles/SelectorOcupacion.vue"
import { mapGetters } from "vuex"
import AxiosHandler from "@/assets/js/class/AxiosHandler.js"
export default {
  data() {
    return {
      fechaSelFormated: null,
      menuPicker: false,
      selectedDestino: null,
      fechasel: null,
      info: null,
      popoverShow: false,
      habitaciones: 1,
      msgInputOcupacion: null,
      form: {
        destino: null,
        inicio: null,
        fin: null
      },
      destinos: [],
      loader: null,
      axiosHandler: null,
      mensajeError: null,
      disabledDates: {
        to: null,
        from: null
      },
      altDestino: null,
      startingDates: null
    }
  },
  watch: {
    form: {
      handler(val) {
        var haynull = false
        Object.keys(val).forEach(function(element) {
          if (val[element] == null) {
            haynull = true
          }
        })
        if (!haynull) {
          this.cupos = []
        }
      },
      deep: true
    }
  },
  mounted() {
    this.validadorPickMoth()
    this.fixMultiSelect()
    this.getDestinos()
  },
  components: {
    SelectorOcupacion
  },
  methods: {
    onSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.doSubmit()
        }
      })
    },
    doSubmit() {
      this.$store.dispatch("cupo/guardarDestino", null)
      this.$store.dispatch("cupo/guardarCuposRs", {
        cupos: [],
        busqueda: null,
        limpiando: true
      })
      var base = this.armarOcupacion(this.formConfig.ocupacion)
      this.exeAxios(this.form.inicio, this.form.fin, this.form.destino, base)
    },
    async exeAxios(from, to, ciudad, base) {
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }

      this.$axiosHandlerAs.prepare(
        process.env.VUE_APP_ASBACK + "/api/cupos-aereos/" + from + "/" + to + "/" + ciudad + "/" + base,
        header
      )
      await this.$axiosHandlerAs.exe()
      const destino = this.destinos.find(d => d.value === this.form.destino)
      this.$store.dispatch("cupo/guardarDestino", destino)
      this.manejarRsCupo(this.$axiosHandlerAs.getData(), this.$axiosHandlerAs.getStatus())
    },
    manejarRsCupo(respuesta, status) {
      switch (status) {
        case 200:
          this.manejarRsCupoOk(respuesta)
          break
        case 500:
          this.showMessage("Ocurrió un error, por favor contacte al administrador.", "error")
          break
        case 401:
          this.showMessage(respuesta.detail, "error")
          this.$forceUpdate()
          this.$router.replace({ name: "login" })
          break
        default:
          this.showMessage("Ocurrio un error inesperado, por favor contacte al administrador. " + status, "error")
          break
      }
    },
    manejarRsCupoOk(respuesta) {
      try {
        this.$store.dispatch("carrito/setGastoReserva", {
          valor: respuesta.gasto_reserva
        })
        let busqueda = typeof respuesta.busqueda === "undefined" ? null : respuesta.busqueda
        this.$store.dispatch("cupo/guardarCuposRs", {
          cupos: respuesta.cupos,
          busqueda: busqueda,
          limpiando: false
        })
      } catch (e) {
        console.log(e)
        this.sinDispo = true
        this.mensajeError = respuesta.detalle
        this.showMessage(respuesta.detalle, "error")
      }
    },
    showMessage(mensaje, tipo) {
      this.$toasted.show(mensaje, {
        theme: "toasted-primary",
        position: "top-right",
        duration: 5000,
        type: tipo
      })
    },
    validadorPickMoth() {
      var hoy = moment()
      this.disabledDates.from = hoy.format("YYYY-MM")
      hoy.add(730, "days")
      this.disabledDates.to = hoy.format("YYYY-MM")
    },
    armarMinMax(data) {
      this.$store.dispatch("cupo/guardarDestino", null)
      this.$store.dispatch("cupo/guardarCuposRs", {
        cupos: [],
        busqueda: null,
        limpiando: true
      })
      this.form.destino = null
      this.form.inicio = moment(data.start).format("YYYY-MM-DD")
      this.form.fin = moment(data.end).format("YYYY-MM-DD")
      document.getElementById("inputDestinoCupo").focus()
      document.getElementById("inputDestinoCupo").click()
    },
    async getDestinos() {
      this.form.destino = null
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      let axios = new AxiosHandler()
      axios.setPassportHandler(this.$passporthandler)
      axios.prepare(process.env.VUE_APP_ASBACK + `/api/get-destinos-cupos/${this.app.alternativo}`, header)
      axios.overlay(false)
      await axios.exe()
      if (axios.getStatus() == 401) {
        return this.$router.replace({ name: "login" })
      }
      if (axios.getStatus() != 200) {
        this.showToasted(
          "Ocurrió un error al buscar los destinos, por favor pruebe de nuevo seleccionando el mes.",
          "error"
        )
        return
      }
      this.destinos = axios.getData().paises
    },
    fixMultiSelect() {
      let tags = document.getElementsByClassName("multiselect__tags")
      if (tags.length === 0) {
        return
      }
      tags[0].style.minHeight = "31px"
      tags[0].style.borderRadius = "0.2rem"
      tags[0].style.borderRadius = "0.2rem"
      tags[0].className += " text-center"
      tags[0].style.lineHeight = "9px"
    },
    cerroSelect() {
      setTimeout(function() {
        let single = document.getElementsByClassName("multiselect__single")
        if (single.length === 0) {
          return
        }
        single[0].style.display = "initial"
        single[0].style.fontSize = "13px"
        single[0].style.lineHeight = "13px"
      }, 1)
    },
    armarOcupacion(ocupacion) {
      var _this = this
      var base = ""
      var totalOcu = ocupacion.length - 1
      ocupacion.forEach(function(el, index) {
        base = base.concat(el.adultos)
        var menores = _this.armarOcupacionMenores(el.edades)
        base = base.concat(menores)
        if (index != totalOcu) {
          base = base.concat(",")
        }
      })
      return base
    },
    armarOcupacionMenores(edades) {
      var menores = ""
      edades.forEach(function(el) {
        menores = menores.concat("-")
        menores = menores.concat(el.edad)
      })
      return menores
    }
  },
  computed: {
    inputDestinosOk: function() {
      if (this.form.inicio == null || this.form.fin == null) {
        return null
      }
      if (this.destinos.length > 1) {
        return null
      }
      return false
    },
    ...mapGetters("app", {
      formConfig: "getFormConfigHtl",
      app: "getApp"
    })
  }
}
</script>
<style scoped>
.pt32 {
  padding-top: 32px;
}
.option-mod-as {
  background: red;
}
</style>
